import { getReq } from 'services/axios/makeRequest';
import envConfig from 'config/envConfig';
import { getAccountsParams } from 'services/models';

const baseUrl = `${envConfig.apiAddress}/api/Accounts`;

export const getSingleUserAccount = id => getReq(`${baseUrl}/Get/${id}`);

export const getAllAccounts = options => getReq(`${baseUrl}/All?${getAccountsParams(options)}`);
